import { render, staticRenderFns } from "./InspectionNotes.vue?vue&type=template&id=0fdf08b4"
import script from "./InspectionNotes.vue?vue&type=script&lang=ts"
export * from "./InspectionNotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports